import {
  createOutputTextItem,
  createWeatherChatItem,
} from '$tablet-app/src/app/chat/ChatItem/functions';
import { AddChatItemFunction } from '$tablet-app/src/app/chat/types';
import { getWeatherQuery } from '@akin-home/weather-frontend';
import * as Location from 'expo-location';
import { ShowWeatherCommand } from '../types';

type ShowWeatherParams = {
  command: ShowWeatherCommand;
  addItem?: AddChatItemFunction;
};

export async function handleShowWeatherCommand(params: ShowWeatherParams) {
  const { command, addItem } = params;

  const coords: { [key: string]: number | undefined } = {
    latitude: undefined,
    longitude: undefined,
  };

  const {
    data: { location, date },
  } = command;

  // No location requested, get current location coordinates
  if (!location) {
    const result = await Location.requestForegroundPermissionsAsync();

    if (result.status !== 'granted') {
      addItem?.(
        createOutputTextItem('Please accept the location sharing permissions')
      );
      return;
    }

    const {
      coords: { latitude, longitude },
    } = await Location.getCurrentPositionAsync({});

    coords.latitude = latitude;
    coords.longitude = longitude;
  }

  const result = await getWeatherQuery({ location, date, ...coords });

  if (!result) {
    addItem?.(
      createOutputTextItem(
        "Sorry, I can't get weather information for you right now"
      )
    );
    return;
  }

  addItem?.(createWeatherChatItem(result));
}
